function getTrimmedValue(
  value: string | number,
  disableTrimOnBlur: boolean
): string | number {
  if (disableTrimOnBlur || typeof value !== "string") return value;
  return value.trim();
}

export { getTrimmedValue };
